import React from "react";
import { NavLink } from "react-router-dom";
import type { RootState } from "app/store";
import { useSlc } from "app/store";
import Headline from "components/headline/Headline";
import RedirectTo from "components/RedirectTo/RedirectTo";
import { WrapperReg } from "app/wrappers";

export const Registration = () => {
  const isAuth = useSlc((state: RootState) => state.user.isAuth);

  const paramsString = window.location.search;
  const searchParams = new URLSearchParams(paramsString);
  if (searchParams.get("ref")) {
    const ref = searchParams.get("ref") as string;
    sessionStorage.setItem("referral_marker", ref);
    // console.log("+++ URL REF PARAM", ref);
  }

  if (!isAuth)
    return (
      <div className="authorization authorization_reg bg-decoration">
        <div className="bg-decoration__login" />
        <div className="container">
          <div className="authorization__wrapper">
            <Headline className="authorization__headline" variant="xl">
              Добро пожаловать в&nbsp;Кружок!
            </Headline>

            <nav className="authorization__nav">
              <NavLink className="authorization__nav--link" to="/sign-up">
                Регистрация
              </NavLink>
              <NavLink className="authorization__nav--link" to="/sign-in">
                Вход
              </NavLink>
            </nav>

            <WrapperReg />
          </div>
        </div>
      </div>
    );
  return <RedirectTo path="/" />;
};
